import React from 'react';
import styles from './Services.module.css';

const services = [
  { src: '/images/service1.png', alt: 'Service 1' },
  { src: '/images/service2.png', alt: 'Service 2' },
  { src: '/images/service3.png', alt: 'Service 3' },
  { src: '/images/service4.png', alt: 'Service 4' },
];

const Services = () => (
  <section className={styles.servicesSection}>
    <h2 className={styles.servicesTitle}>Our Services</h2>
    <div className={styles.servicesGrid}>
      {services.map((service, idx) => (
        <div className={styles.serviceItem} key={idx}>
          <img src={service.src} alt={service.alt} className={styles.serviceImage} />
        </div>
      ))}
    </div>
  </section>
);

export default Services;
